module.exports = require('./libheif/libheif.js')();
